// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"38d28ef5","171":"256049f1","220":"5f358081","400":"8dceaf5a","453":"813e4bde","842":"d4ee0c07","998":"bb29dda2"}[chunkId] + ".chunk.js";
};